module.exports = __webpack_public_path__ + "static/media/nodata.1c72e77a.jpg";